export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-3xl mx-auto text-center">
        <div className="flex items-center justify-center gap-3 mb-10">
          <span className="w-1 h-6 bg-primary-500 rounded-full"></span>
          <h2 className="text-foreground-900 font-heading text-2xl md:text-3xl font-bold">
            联系我们
          </h2>
        </div>

        <div className="bg-background-100 rounded-xl p-6 md:p-10 border border-background-200/60">
          <p className="text-foreground-500 text-sm md:text-base leading-relaxed mb-6">
            如果您有影片资源建议、播放问题反馈或商务合作意向，欢迎通过以下方式联系我们。哈哈影院团队将及时为您处理。
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <a
              href="#"
              className="whitespace-nowrap inline-flex items-center justify-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-lg transition-colors cursor-pointer text-sm"
            >
              <i className="ri-mail-line"></i>
              资源建议反馈
            </a>
            <a
              href="#"
              className="whitespace-nowrap inline-flex items-center justify-center gap-2 px-6 py-3 border border-foreground-300/40 hover:border-foreground-500 text-foreground-700 hover:text-foreground-900 font-medium rounded-lg transition-colors cursor-pointer text-sm"
            >
              <i className="ri-shake-hands-line"></i>
              商务合作咨询
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}